// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"726a9731","766":"8d5987e1","905":"dee58625","985":"f0ced78b","998":"5f1fd986"}[chunkId] + ".chunk.js";
};